<template src="./ConnectKiotvietComponent.html"></template>
<script>
import IconHome from "@/components/icons/IconHome.vue";
import BreadcrumbComponent from "@/components/breadcrumb/BreadcrumbComponent.vue";
import InputTextNormal from "@/components/inputs/input-text/normal/InputTextNormal.vue";
import SelectNormal from "@/components/inputs/select/normal/SelectNormal.vue";
import ButtonSearchComponent from "@/components/buttons/button-search/ButtonSearchComponent.vue";
import {computed, ref} from "vue";
import {useRouter} from "vue-router";
import {useSyncKiotviet} from "@/stores/syncKiotviet.js";
import {useAccountStore} from "@/stores/account.js";
import CommonService from "@/services/common.service.ts";
import {ErrorText} from "@/supports/error-message.constant.ts";
import {AppConstant} from "@/supports/app.constant.ts";
export default {
  name: 'ConnectKiovietComponent',
  components: {
    ButtonSearchComponent,
    SelectNormal,
    InputTextNormal,
    BreadcrumbComponent,
    IconHome
  },
  setup() {
    const errors = ref(true);
    const dataSyncKiotViet = ref({
      retailer: {
        id: 'retailer',
        label: 'Tên Gian Hàng',
        placeholder: 'Tên Gian Hàng',
        value: '',
        error: '',
        isError: false,
        required: true
      },
      client_id: {
        id: 'client_id',
        label: 'Client Id',
        placeholder: 'Client Id',
        value: '',
        error: '',
        isError: false,
        required: true
      },
      client_secret: {
        id: 'client_secret',
        label: 'Mã bảo mật',
        placeholder: 'Mã bảo mật',
        value: '',
        error: '',
        isError: false,
        required: true
      },
    })
    const router = useRouter();
    const syncKiotvietStore = useSyncKiotviet()
    const accountStore = useAccountStore()
    const messError = ref('');

    async function connectKiotviet() {
      messError.value = '';
      for (const item in dataSyncKiotViet.value) {
        validateForm(dataSyncKiotViet.value[item].value, item)
      }
      if(checkSubmitActive.value) {
        const params = {
          m_company_id: accountStore.account.company.id,
          retailer: dataSyncKiotViet.value.retailer.value,
          client_id: dataSyncKiotViet.value.client_id.value,
          client_secret: dataSyncKiotViet.value.client_secret.value,
        }
        const url = AppConstant.URL_API_LOCAL + 'api/v1/sync-kiotviet/connect';
        try {
          const resultConnect = await syncKiotvietStore.connect(url, params);

          if (resultConnect?.status === 'success') {
            window.location.reload();
          } else {
            messError.value = resultConnect?.message || 'Kết nối thất bại. Vui lòng thử lại.';
          }
        } catch (error) {
          console.error('Lỗi kết nối KiotViet:', error);
          messError.value = 'Lỗi máy chủ hoặc kết nối mạng. Vui lòng thử lại.';
        }
      }
    }

    function validateForm(value, name) {
      if(name === 'retailer') {
        dataSyncKiotViet.value.retailer.isError = false;
        dataSyncKiotViet.value.retailer.error = ''
        errors.value = false
        if(!value) {
          dataSyncKiotViet.value.retailer.isError = true;
          dataSyncKiotViet.value.retailer.error = ErrorText.REQUIRED(dataSyncKiotViet.value.retailer.label);
          errors.value = true
        }
      }
      if(name === 'client_id') {
        dataSyncKiotViet.value.client_id.isError = false;
        dataSyncKiotViet.value.client_id.error = ''
        errors.value = false
        if(!value) {
          dataSyncKiotViet.value.client_id.isError = true;
          dataSyncKiotViet.value.client_id.error = ErrorText.REQUIRED(dataSyncKiotViet.value.client_id.label);
          errors.value = true
        }
      }
      if(name === 'client_secret') {
        dataSyncKiotViet.value.client_secret.isError = false;
        dataSyncKiotViet.value.client_secret.error = ''
        errors.value = false
        if(!value) {
          dataSyncKiotViet.value.client_secret.isError = true;
          dataSyncKiotViet.value.client_secret.error = ErrorText.REQUIRED(dataSyncKiotViet.value.client_secret.label);
          errors.value = true
        }
      }
    }
    function onChange(value, name) {
      dataSyncKiotViet.value[name].value = value
    }

    const removeError = () => {
      messError.value = '';
    };

    const checkSubmitActive = computed(() => {
      return !errors.value;
    })

    return {
      dataSyncKiotViet,
      CommonService,
      errors,
      onChange,
      validateForm,
      checkSubmitActive,
      connectKiotviet,
      messError,
      removeError
    }
  }
}
</script>

<style lang="scss">
.dashboard-page {
  margin-top: 80px;
  margin-left: 80px;
  height: 100%;
  .title-page {
    padding: 15px 30px;
    background-color: #fff;
  }
  .container-fluid {
    padding-top: 30px;
    .card {
      margin-bottom: 30px;
      letter-spacing: .5px;
      box-shadow: 0 9px 20px rgba(46,35,94,.07);
      .card-body {
        padding: 30px;
        border-radius: 15px;
        background-color: #ffffff;
      }
    }
  }
}
</style>